import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import useTabStyles from './styles.esm.js';

var Tab = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var selected = props.selected,
      disabled = props.disabled,
      id = props.id,
      rest = _objectWithoutPropertiesLoose(props, ["selected", "disabled", "id"]);

  var styleProps = useTabStyles(props);
  return React__default.createElement(Box, _extends({
    ref: ref,
    role: "tab",
    as: "button",
    type: "button",
    tabIndex: selected ? 0 : -1,
    id: "tab-" + id,
    disabled: disabled,
    "aria-selected": selected,
    "aria-disabled": disabled,
    "aria-controls": "panel-" + id
  }, styleProps, rest));
});

if (__DEV__) {
  Tab.displayName = 'Tab';
}

export default Tab;
//# sourceMappingURL=index.esm.js.map
